<div class="eb-payment-method">
  <h3>{{ 'checkoutProgress.paymentDetails' | cxTranslate }}</h3>
  <form [formGroup]="paymentMethodsForm" class="eb-payment-method__po-number-form">
    <h5 class="eb-payment-method__label">{{ 'checkoutProgress.orderReference' | cxTranslate }}</h5>
    <input
      type="text"
      [maxlength]="35"
      formControlName="poNumber"
      class="eb-payment-method__po-number-input"
    />
  </form>
  <h5 class="eb-payment-method__label">{{ 'checkoutProgress.paymentDetails' | cxTranslate }}</h5>
  <span class="eb-payment-method__payment-type">{{
    (activeCart$ | async).paymentType?.displayName
  }}</span>

  <eb-checkout-step-buttons
    backButtonLabel="checkout.backToCart"
    [disabled]="!(activeCart$ | async).paymentType?.code"
    (back)="back()"
    (next)="next()"
  >
  </eb-checkout-step-buttons>
</div>
